import { Link } from "gatsby"

import { Img } from "../../../../layout/Img"
import { ProfileLink } from "./ProfileLink"

export const ProfileHover = ({ profiles }) => {
  if (!profiles || profiles.length === 0) {
    return null
  }

  return (
    <div className="container flex flex-col mx-auto md:w-9/12 ">
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        {profiles?.map((item, index) => (
          <Link key={index} to={`/${item.uri}`}>
            <div
              className="relative flex justify-center mx-8"
              style={{ borderRadius: "50%" }}
            >
              <Img
                image={item.profilePicture[0]}
                className="rounded-full"
                imgStyle={{ borderRadius: "100%" }}
              />
              <div
                style={{ borderRadius: "50%" }}
                className="absolute bottom-0 w-full h-full cursor-pointer hover:bg-primary hover:bg-opacity-80"
              >
                <div className="z-10 flex items-center justify-center w-full h-full opacity-0 hover:opacity-100">
                  <div className="">
                    <h2 className="px-2 text-sm font-semibold text-center text-white xl:text-base">
                      {item.title}
                    </h2>
                    <span className="flex justify-center px-2 text-xs font-light text-center text-white ">
                      {item.profileRole}
                    </span>
                    <div className="flex justify-center">
                      {item.profileLinks?.map(({ uid, ...rest }) => (
                        <div key={uid} className="mt-2 text-center">
                          <ProfileLink
                            {...rest}
                            customClass="text-white mx-1"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}
